(($) => {
    const currentSlide = $('.services--arrows__current');

    $('#services__slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        draggable: true,
        autoplay: false,
        arrows: false,
        dots: false,
        appendDots: $('.services--dots'),
        adaptiveHeight: true
    });

    $('.services--arrows__next').on('click', function() {
        $('#services__slider').slick('slickNext');
        updateCurrentSlide();
    });

    $('.services--arrows__prev').on('click', function() {
        $('#services__slider').slick('slickPrev');
        updateCurrentSlide();
    });

    $('#services__slider').on('swipe', function(event, slick, direction){
        updateCurrentSlide();
    });

    function updateCurrentSlide() {
        const current = $('.slick-current').find('.services--card');
        currentSlide.text(current.data('service'));
    }

    $("#myRange").on("input change", function(e) {
        const slider_position = e.target.value;
        // Update the width of the foreground image
        $('.swapper .image--primary').css('width', slider_position + "%");
        $('.swapper_slider_button').css('left', `calc(${slider_position}% - 24px)`)
    });

})(jQuery);